import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/* Inline snippet u index.html već šalje PageView za prvo učitavanje,
   ovde hvatamo samo klijentske promene rute (SPA nema pravi reload).
   Admin i bend panel se preskaču da interni saobraćaj ne ulazi u
   statistiku oglasa. */
const MetaPixelPageView = () => {
  const { pathname } = useLocation();
  const isFirstLoad = useRef(true);

  useEffect(() => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }
    if (pathname.startsWith("/admin") || pathname.startsWith("/bend-panel")) {
      return;
    }
    if (window.fbq) {
      window.fbq("track", "PageView");
    }
  }, [pathname]);

  return null;
};

export default MetaPixelPageView;
